/**
 * DemoNotice — a calm, professional banner shown whenever a screen or section
 * renders demonstration data because the backend endpoint isn't wired up yet.
 *
 * Copy is bilingual (RU/EN/AZ/KA) via the `demo.*` i18n keys. Gold tone keeps it
 * informational — not an error.
 */
import { XStack, YStack, Text } from 'tamagui'

import { useApp } from '../i18n'
import { tone as toneOf } from '../theme/tones'
import { Icon } from './Icon'

export function DemoNotice() {
  const { l } = useApp()
  const c = toneOf('gold')
  const title = l('demo.title')
  const body = l('demo.pending.body')

  return (
    <XStack
      alignSelf="stretch"
      accessibilityRole="alert"
      accessibilityLabel={`${title}. ${body}`}
      backgroundColor={c.soft}
      borderWidth={1}
      borderColor={c.soft}
      borderLeftWidth={3}
      borderLeftColor={c.solid}
      borderRadius={7}
      gap={10}
      paddingVertical={11}
      paddingHorizontal={12}
      alignItems="flex-start"
    >
      <YStack paddingTop={1} flexShrink={0}>
        <Icon name="triangle-alert" size={16} color={c.text} />
      </YStack>
      <YStack flex={1} gap={2}>
        <Text fontSize={13} fontWeight="700" color={c.text}>
          {title}
        </Text>
        <Text fontSize={12} color="$muted" lineHeight={17}>
          {body}
        </Text>
      </YStack>
    </XStack>
  )
}
